import React from 'react';
import './TestAnalytics.css';

const LeaderboardTable = ({ results, totalMarks }) => {
  if (!results || results.length === 0) {
    return <p className="td-empty">No completed attempts available.</p>;
  }

  const getRankBadge = (rank) => {
    if (rank === 1) return <span className="ta-rank-badge ta-rank-1">1</span>;
    if (rank === 2) return <span className="ta-rank-badge ta-rank-2">2</span>;
    if (rank === 3) return <span className="ta-rank-badge ta-rank-3">3</span>;
    return <span className="ta-rank-badge ta-rank-other">{rank}</span>;
  };

  const getAccuracyClass = (acc) => {
    if (acc >= 75) return 'ta-acc-high';
    if (acc >= 50) return 'ta-acc-med';
    return 'ta-acc-low';
  };

  return (
    <div className="ta-table-container">
      <table className="ta-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Student</th>
            <th>Roll No</th>
            <th>Score</th>
            <th>Accuracy</th>
            <th>Time Taken</th>
          </tr>
        </thead>
        <tbody>
          {results.map((r, i) => {
            const scorePercent = totalMarks > 0 ? (r.score / totalMarks) * 100 : 0;
            return (
              <tr key={r.id || i}>
                <td>{getRankBadge(r.rank || i + 1)}</td>
                <td><strong>{r.student_name}</strong></td>
                <td>{r.roll_number}</td>
                <td>
                  <div>{r.score} / {totalMarks}</div>
                  <div className="ta-progress-bar-bg">
                    <div className="ta-progress-fill" style={{ width: `${scorePercent}%` }}></div>
                  </div>
                </td>
                <td className={getAccuracyClass(r.accuracy)}>{r.accuracy}%</td>
                <td>{r.time_taken}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderboardTable;
